import type { DomEventType } from '@interstate/components/InterstateEvents';
import { DATA_TESTID_INPUT_PREFIX } from '../constants';

export const findInputTestId = (event: DomEventType | undefined): string | undefined => {
    const maxGetParentAttempts = 3;

    let element = (event as MouseEvent)?.relatedTarget as Element | null;

    for (let i = 0; i <= maxGetParentAttempts && element; i++) {
        if (element && typeof element.getAttribute === 'function') {
            const testId = element.getAttribute('data-testid');

            if (testId) {
                return testId;
            }
        }
        element = element.parentElement;
    }

    return undefined;
};

export const getIsProductInputFocused = (event: DomEventType | undefined): boolean => {
    const testId = findInputTestId(event);

    if (!testId) {
        return false;
    }

    return Object.values(DATA_TESTID_INPUT_PREFIX).some((inputPrefix) => testId.includes(inputPrefix));
};
